export const waitOneSecondAndCallFunc = async (callback = () => {}) => {
  const delayBetweenAttempts = 1000

  await new Promise((resolve) => setTimeout(resolve, delayBetweenAttempts))

  callback()
}
